import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Ticket, Loader2 } from 'lucide-react';
import adminAxios from './adminAxios';
import { Card } from '../../components/ui/card';

const currency = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const AdminVitalPassControl = () => {
  const [data, setData] = useState({ users: [], token_value: 0, total_users: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await adminAxios.get('/admin/vitalpass/overview');
        setData(data);
      } catch (err) {
        toast.error('Erro ao carregar');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="p-4" data-testid="admin-vitalpass-control">
      <h2 className="text-2xl font-black text-slate-900 mb-4 flex items-center gap-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
        <Ticket className="w-6 h-6 text-teal-600" /> Controle VITALPASS
      </h2>
      <div className="mb-4 flex gap-3 flex-wrap">
        <Card className="p-3 min-w-[160px]">
          <p className="text-[10px] uppercase text-slate-500 font-semibold">Total Alunos Personal</p>
          <p className="text-2xl font-black text-slate-900">{data.total_users}</p>
        </Card>
        <Card className="p-3 min-w-[160px]">
          <p className="text-[10px] uppercase text-slate-500 font-semibold">Valor por Token</p>
          <p className="text-2xl font-black text-teal-700">{currency(data.token_value)}</p>
        </Card>
      </div>

      {loading ? (
        <div className="text-center py-8"><Loader2 className="w-6 h-6 animate-spin mx-auto text-teal-600" /></div>
      ) : (
        <Card className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50">
              <tr className="text-left border-b border-slate-200">
                <th className="py-2 px-3">Usuário</th>
                <th>E-mail</th>
                <th>Plano</th>
                <th className="text-center">Total</th>
                <th className="text-center">Utilizados</th>
                <th className="text-center">Disponíveis</th>
                <th className="text-center">Solicitações</th>
                <th>Renovação</th>
              </tr>
            </thead>
            <tbody data-testid="vp-control-body">
              {data.users.length === 0 ? (
                <tr><td colSpan={8} className="text-center py-6 text-slate-500">Nenhum aluno com plano Personal ainda</td></tr>
              ) : data.users.map((u) => (
                <tr key={u.user_id} className="border-b border-slate-100">
                  <td className="py-2 px-3 font-semibold">{u.name}</td>
                  <td className="text-xs">{u.email}</td>
                  <td className="text-xs">{u.plan_name}</td>
                  <td className="text-center">{u.total}</td>
                  <td className="text-center text-blue-700">{u.used}</td>
                  <td className="text-center font-bold text-teal-700">{u.balance}</td>
                  <td className="text-center">{u.requests_count}</td>
                  <td className="text-xs text-slate-500">{u.cycle_end ? new Date(u.cycle_end).toLocaleDateString('pt-BR') : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
};

export default AdminVitalPassControl;
